import { Pivot, PivotItem, Spinner } from '@fluentui/react';
import useAxios from 'axios-hooks';
import { Formik } from 'formik';
import React, { useState, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import ChoiceGroup from '../../../../Forms/ChoiceGroup';
import Form from '../../../../Forms/Form';
import CobrandDropDown from '../../../Checklist/Checklists/Forms/CobrandDropDown';
import { NavigationalButtons } from '../../../Content/Audio CMS/CreateAudioWizard/CreateAudioWizard';
import DashboardTasksDropDown from '../Components/DashboardTasksDropDown';
import FeatureSummary from '../../../../Util/FeatureSummary';

const DashboardTasksWizardPage = () => {
    const history = useHistory();
    // State
    let { cobrandDashboardTaskId: cobrandDashboardTaskIdFromParams } = useParams();
    let cobrandDashboardTaskId = cobrandDashboardTaskIdFromParams ? parseInt(cobrandDashboardTaskIdFromParams) : -1;
    const [selectedKey, setSelectedKey] = useState(0); //unused but future proofing / want to make it consistant with other wizards
    const [formikInitialValues, setFormikInitialValues] = useState(null);

    // Queries
    const [{ postIsLoading }, postNew] = useAxios(
        { url: 'internal/dashboard-tasks/cobrand-exclusions', method: 'post' },
        { manual: true }
    );
    const [{ putIsLoading }, putUpdate] = useAxios(
        { url: 'internal/dashboard-tasks/cobrand-exclusions', method: 'put' },
        { manual: true }
    );

    const [{ data: allCobrandDashboardTasks, getAllIsLoading }, getAll] = useAxios(
        { url: 'internal/dashboard-tasks/cobrand-exclusions', method: 'get' },
        { manual: true }
    );

    useEffect(() => {
        if (cobrandDashboardTaskId > 0) {
            getAll().then((resp) => {
                let thisTask = resp.data.find((x) => (x.cobrandDashboardTaskId === cobrandDashboardTaskId));
                if (!thisTask) throw new Error('Invalid cobrandDashboardTaskId!');
                setFormikInitialValues({
                    cobrandDashboardTaskId: thisTask.cobrandDashboardTaskId,
                    cobrandId: thisTask.cobrandId,
                    dashboardTaskSlug: thisTask.dashboardTaskSlug,
                    onOffDefault: thisTask.onOffDefault,
                });
            });
        } else {
            setFormikInitialValues({
                cobrandDashboardTaskId,
                cobrandId: null,
                dashboardTaskSlug: null,
                onOffDefault: false,
            });
        }
    }, []);

    const onSubmit = (submittedValues) => {
        console.log({ onsubmit });
        if (cobrandDashboardTaskId > 0) {
            putUpdate({ data: submittedValues }).then(() => {
                history.push('/cobrand-settings-feature/dashboard-tasks/');
            });
        } else {
            postNew({ data: submittedValues }).then(() => {
                history.push('/cobrand-settings-feature/dashboard-tasks/');
            });
        }
    };

    if (!formikInitialValues) return <Spinner />;
    return (
        <Formik initialValues={formikInitialValues} onSubmit={onSubmit} isInitialValid={false}>
            {({ dirty, values }) => {
                return (
                    <>
                        <Pivot selectedKey={String(selectedKey)} onLinkClick={() => {}}>
                            <PivotItem headerText="Basic Info" itemKey="0">
                                <div className="mt-1">
                                    <Form>
                                        <CobrandDropDown
                                            name="cobrandId"
                                            label="Cobrand"
                                            byNameOrId="id"
                                            isMulti={false}
                                            required
                                            isDisabled={values.cobrandDashboardTaskId > 0}
                                        />
                                        <DashboardTasksDropDown
                                            name="dashboardTaskSlug"
                                            label="Dashboard Task"
                                            isMulti={false}
                                            required
                                            isDisabled={values.cobrandDashboardTaskId > 0}
                                        />
                                        <ChoiceGroup
                                            label="State"
                                            options={[
                                                { key: false, text: 'Disabled' },
                                                { key: true, text: 'Enabled' },
                                            ]}
                                            name="onOffDefault"
                                            required
                                        />
                                        <NavigationalButtons
                                            onNextProps={{
                                                type: 'submit',
                                                text: 'Save',
                                                disabled: !values.cobrandId || !values.dashboardTaskSlug,
                                            }}
                                        />
                                    </Form>
                                </div>
                            </PivotItem>
                        </Pivot>
                        <FeatureSummary
                            label="About Dashboard Task Exclusions"
                            summary="Configure per-cobrand exclusions for dashboard tasks. Select a cobrand and a dashboard task slug, then set whether the task should be enabled or disabled for that specific cobrand. Use this to override the global task visibility settings."
                        />
                    </>
                );
            }}
        </Formik>
    );
};

export default DashboardTasksWizardPage;
